exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-ret__lead[data-v-d7100558]{margin-bottom:14px}.pi-ret__export[data-v-d7100558]{margin-left:auto}.pi-ret__note[data-v-d7100558]{margin-top:8px}.pi-ret__table[data-v-d7100558]{border-collapse:separate;border-spacing:2px}.pi-ret__cell[data-v-d7100558],.pi-ret__table th[scope=row][data-v-d7100558]{font-weight:600;white-space:nowrap}.pi-ret__cell[data-v-d7100558]{min-width:64px;border-radius:3px;text-align:center}.pi-ret__cell.is-pending[data-v-d7100558]{border:1px dashed #c5cad3;background:#fff;color:#6b7280;font-weight:400}.pi-ret__average td[data-v-d7100558],.pi-ret__average th[data-v-d7100558]{border-bottom:2px solid #c5cad3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7100558","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/restricted/productIntelligence/piRetention.vue
// module id = 1770
// module chunks = 0